module.exports = __webpack_public_path__ + "img/58.7fe16875.jpg";